<template>
  <b-container>
    <div class="headerimg">
      <h1>DIY Psychic Fish</h1>
    </div>
    <p>How do fish feel, and how do you feel about fish?</p>
    <p>
      Use this DIY toolkit to create an interactive public engagement tool that encourages fishy conversations, 
      courtesy of the <a href="https://animalresearchnexus.org/blogs/becoming-psychic-fish-0" target="_blank">Animal Research Nexus</a> project. 
    </p>
    <p><em>Adapt, re-use, and enjoy!</em></p>
    <hr/>
    <p> Read the <a :href="`${publicPath}DIY%20Psychic%20Fish%20Instructions.pdf`" target="_blank" >DIY Psychic Fish Instructions</a></p>
    <Form style="margin-bottom:2em;" />
    <hr/>
    <h2>Terms of use</h2>
    <p>You are free to adapt our Psychic Fish for your own purposes without seeking prior approval from us. Please acknowledge the Animal Research Nexus in your creation. </p>  
    <p><strong>Disclaimer</strong><br/>
    The adapted Psychic Fish cards generated using this site are the responsibility of those who generate them and their use of the AnNex Psychic Fish template does not imply an endorsement of them or any entity they represent. 
    </p>
    <div class="row">
      <div class="col-6 col-md-4 order-1" style="margin-bottom:2em;">
        <a href="https://animalresearchnexus.org" target="_blank">
          <img class="img-fluid" :src="`${publicPath}img/AnNex_Logo_1200.png`" title="Animal Research Nexus homepage">
        </a>
      </div>
   </div>        
   <p style="text-align:right;">
      Built by <a href="https://www.switchsystems.co.uk" target="_blank">Kris and Tom</a>
    </p>
  </b-container>
</template>

<script>
import Form from './components/Form.vue'

export default {
  name: 'App',
  components: {
    Form
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  }
}
</script>

<style>
.headerimg {
  background: url(./assets/img/ps_header.jpg) no-repeat center center;
  background-size: cover;
  height: 20em;
  text-align: center;
  border-bottom:10px solid #ea502f;
  margin-bottom: 1em;
}
.headerimg h1 { 
  background-color:#ea502f;
  color:#fff;
  display:inline-block;
  padding: 0.5em 0.5em;
  text-align: center;
  margin:3em auto;
}
</style>